<template>
  <div
    v-if="isSideBarTitleShown && shouldShowSideBarTitle"
    class="title-section d-flex align-center ga-2"
    :class="[
      !isOpenMobileSideBar &&
      (isMobile || isTablet || isLaptop) &&
      iconName !== 'mdi mdi-briefcase-outline'
        ? 'side-bar-border'
        : '',
    ]"
    @click="openMobileSideBar"
  >
    <!-- <v-icon size="20" :class="iconClass" :icon="iconName" />
    <h2 :class="mode">{{ title }}</h2> -->
    <IconTitle :iconName="iconName" :mode="mode" :title="title" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IconTitle from "../UI/IconTitle.vue";

export default {
  components: { IconTitle },
  props: {
    isSideBarTitleShown: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "סינונים",
    },
    mode: {
      type: String,
    },
    iconName: {
      type: String,
      default: "mdi-filter-multiple-outline",
    },
  },
  methods: {
    openMobileSideBar() {
      if (
        (this.isMobile || this.isTablet || this.isLaptop) &&
        !this.isOpenMobileSideBar
      ) {
        this.$store.commit("setIsOpenMobileSideBar", true);
      }
    },
  },
  computed: {
    iconClass() {
      return `${this.mode}-icon`;
    },
    shouldShowSideBarTitle() {
      // Hide the floating filter button for customers mode on mobile/tablet/laptop
      // as we now have an inline filter button in the customer labels section
      if ((this.isMobile || this.isTablet || this.isLaptop)) {
        return false;
      }
      return true;
    },
    ...mapGetters({
      isMobile: "isMobile",
      isTablet: "isTablet",
      isLaptop: "isLaptop",
      isOpenMobileSideBar: "isOpenMobileSideBar",
    }),
  },
};
</script>

<style scoped lang="scss">
.side-bar-border {
  border: 1px solid $grayBorderColor;
  border-radius: 30px;
  width: fit-content;
  padding: 5px 10px !important;
  cursor: pointer;
  position: fixed;
  right: 10px;
  top: 120px;
  background: white;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 3;
}
</style>
